import { Shimmer, ShimmerElementsGroup, ShimmerElementType } from 'office-ui-fabric-react';
import React from 'react';
import { Stack } from '../Stack';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const ShimmerLoader = props => {
  const getDefaultShimmer = () => {
    return /*#__PURE__*/_jsx(Stack, {
      children: /*#__PURE__*/_jsx(ShimmerElementsGroup, {
        shimmerElements: [{
          type: ShimmerElementType.line,
          width: '100%',
          height: props.height || 32
        }]
      })
    });
  };
  const getLabelShimmer = () => {
    return /*#__PURE__*/_jsx(Stack, {
      children: /*#__PURE__*/_jsx(ShimmerElementsGroup, {
        shimmerElements: [{
          type: ShimmerElementType.line,
          height: 14
        }]
      })
    });
  };
  const shouldRenderContent = !(props.isBlocking && props.isLoading);
  return /*#__PURE__*/_jsxs(Stack, {
    styles: props.wrapperStyleProps,
    children: [props.withLabel && /*#__PURE__*/_jsx(Shimmer, {
      "data-id": 'shimmer-loader',
      ariaLabel: 'shimmer-label-loading',
      styles: {
        root: {
          paddingBottom: props.isLoading && 5 || 0,
          paddingTop: props.isLoading && 10 || 0
        }
      },
      customElementsGroup: getLabelShimmer(),
      isDataLoaded: !props.isLoading
    }), /*#__PURE__*/_jsx(Stack, {
      children: /*#__PURE__*/_jsx(Shimmer, {
        ariaLabel: 'shimmer-loading',
        isDataLoaded: !props.isLoading,
        customElementsGroup: props.customShimmers || getDefaultShimmer(),
        children: shouldRenderContent && props.children
      })
    })]
  });
};